interface CatalogIconProps {
  isActive?: boolean;
}

export const CatalogIcon: React.FC<CatalogIconProps> = ({ isActive = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M15.9666 1H2.82211C1.78505 1 0.944336 1.84071 0.944336 2.87778V16.0222C0.944336 17.0593 1.78505 17.9 2.82211 17.9H15.9666C17.0036 17.9 17.8443 17.0593 17.8443 16.0222V2.87778C17.8443 1.84071 17.0036 1 15.9666 1Z"
        stroke={isActive ? "var(--active-color)" : "#83829D"}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.944336 6.6333H17.8443"
        stroke={isActive ? "var(--active-color)" : "#83829D"}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5791 17.9V6.6333"
        stroke={isActive ? "var(--active-color)" : "#83829D"}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
